export const ROLE_LABELS = {
  platform_admin: "Admin Platform",
  school_admin: "Admin Sekolah",
  kepala_sekolah: "Kepala Sekolah",
  operator: "Pegawai ASN",
  guru: "Guru",
  wali_kelas: "Wali Kelas",
  siswa: "Siswa",
  orang_tua: "Orang Tua/Wali",
  pegawai_non_asn: "Pegawai Non-ASN",
  petugas_presensi: "Petugas Presensi",
};

export const TENANT_STATUS = {
  Pending_Verification: { label: "Menunggu Verifikasi", tone: "warn" },
  Active: { label: "Aktif", tone: "ok" },
  Restricted: { label: "Dibatasi", tone: "danger" },
  Deactivated: { label: "Dinonaktifkan", tone: "muted" },
};

export const MEMBER_STATUS = {
  active: { label: "Aktif", tone: "ok" },
  inactive: { label: "Nonaktif", tone: "muted" },
};

export const INVITE_STATUS = {
  pending: { label: "Menunggu", tone: "info" },
  used: { label: "Sudah Digunakan", tone: "ok" },
  revoked: { label: "Dicabut", tone: "danger" },
  expired: { label: "Kedaluwarsa", tone: "muted" },
};

export const REVIEW_STATUS = {
  open: { label: "Perlu Ditinjau", tone: "warn" },
  linked: { label: "Ditautkan", tone: "ok" },
  rejected: { label: "Ditolak", tone: "muted" },
};

export const SUBSCRIPTION_STATUS = {
  Active: "Aktif",
  Past_Due: "Lewat Jatuh Tempo",
  Grace_Period: "Masa Tenggang",
  Suspended: "Ditangguhkan",
  Expired: "Kedaluwarsa",
};

// Status satu baris tagihan akun pada periode berjalan = LAPIS PERTAMA: sekolah ke reseller.
// Sekolah hanya perlu tahu "LUNAS" atau "Belum bayar" — rincian lapis di balik layar tidak mereka urus.
export const BILL_STATUS = {
  PENDING: { label: "Belum bayar", tone: "muted" },
  CLAIMED: { label: "LUNAS", tone: "ok" },
  CONFIRMED: { label: "LUNAS", tone: "ok" },
  ACTIVE: { label: "LUNAS", tone: "ok" },
  WAIVED: { label: "DIBEBASKAN", tone: "ok" },
};

// Kondisi akses dihitung dari status tagihan baris itu sendiri + tanggal hari ini (WIB),
// bukan dari kolom terpisah: status menentukan lapis mana yang sudah selesai, tanggal menentukan tenggang.
export const ACCESS_STATE = {
  AKTIF: { label: "Akses aktif", tone: "ok" },
  GRACE: { label: "Tenggang s.d. tgl 3", tone: "warn" },
  TUNGGAK_RESELLER: { label: "Menunggu verifikasi pembayaran", tone: "warn" },
  TERKUNCI: { label: "Login ditolak", tone: "danger" },
  GERBANG: { label: "Gerbang presensi", tone: "info" },
};

export const RESELLER_STATUS = {
  Aktif: { label: "Aktif", tone: "ok" },
  Diblokir: { label: "Diblokir", tone: "danger" },
};

// Status satu setoran kulakan (lapis kedua: reseller ke founder).
export const SETTLEMENT_STATUS = {
  terverifikasi: { label: "Terverifikasi", tone: "ok" },
  menunggu_verifikasi: { label: "Menunggu verifikasi founder", tone: "warn" },
};

const idNumber = new Intl.NumberFormat("id-ID");

export function rupiah(v) {
  return `Rp${idNumber.format(Math.max(0, Math.round(Number(v) || 0)))}`;
}

export const ACTION_LABELS = {
  "auth.login": "Masuk",
  "auth.logout": "Keluar",
  "auth.login_failed": "Gagal masuk",
  "auth.switch_school": "Berpindah sekolah",
  "auth.password_changed": "Kata sandi diubah sendiri",
  "auth.password_reset": "Kata sandi direset lewat tautan",
  "members.password_reset_link": "Tautan reset sandi anggota dikirim",
  "account.password_reset_link": "Tautan reset sandi akun dikirim",
  "access.denied": "Akses ditolak",
  "tenant.created": "Sekolah dibuat",
  "tenant.status_changed": "Status sekolah diubah",
  "invitation.created": "Undangan dibuat",
  "invitation.revoked": "Undangan dicabut",
  "invitation.accepted": "Undangan diterima",
  "user.created": "Akun dibuat",
  "membership.created": "Anggota ditambahkan",
  "membership.status_changed": "Status anggota diubah",
  "membership.role_changed": "Peran anggota diubah",
  "membership.person_updated": "Data anggota diperbarui",
  "membership.registration_numbers_changed": "Nomor registrasi anggota diubah",
  "school.profile_updated": "Profil sekolah diperbarui",
  "members.exported": "Data anggota diekspor",
  "identity_review.created": "Tinjauan identitas dibuat",
  "identity_review.resolved": "Tinjauan identitas diselesaikan",
  "platform_admin.bootstrapped": "Admin Platform awal dibuat",
  "tenant.metadata_changed": "Data sekolah dikoreksi",
  "academic.year_created": "Tahun ajaran dibuat",
  "academic.semester_created": "Semester ditambahkan",
  "academic.class_created": "Kelas dibuat",
  "academic.class_updated": "Kelas diperbarui",
  "academic.subject_created": "Mata pelajaran dibuat",
  "academic.assignment_created": "Guru ditugaskan",
  "academic.assignment_ended": "Penugasan guru diakhiri",
  "academic.schedule_created": "Jadwal pelajaran dibuat",
  "academic.schedule_updated": "Jadwal pelajaran diubah",
  "academic.schedule_deleted": "Jadwal pelajaran dihapus",
  "guardian.relation_created": "Relasi orang tua diajukan",
  "guardian.relation_verified": "Relasi orang tua diverifikasi",
  "guardian.relation_revoked": "Relasi orang tua dicabut",
  "attendance.device_created": "Perangkat RFID ditambahkan",
  "attendance.device_updated": "Perangkat RFID diperbarui",
  "attendance.device_key_rotated": "Kunci perangkat RFID diganti",
  "attendance.card_mapped": "Kartu RFID dipetakan",
  "attendance.card_status_changed": "Status kartu RFID diubah",
  "attendance.record_corrected": "Kehadiran dikoreksi",
  "attendance.manual_submitted": "Presensi manual dikirim",
  "attendance.scan_submitted": "Presensi pemindai HP dikirim",
  "grades.settings_updated": "Pengaturan penilaian diubah",
  "grades.plan_updated": "Komponen penilaian disimpan",
  "grades.entries_saved": "Nilai siswa disimpan",
  "grades.report_generated": "Draf rapor disusun",
  "grades.report_updated": "Rapor diperbarui",
  "grades.report_published": "Rapor diterbitkan",
  "grades.report_unpublished": "Penerbitan rapor ditarik",
  "feed.post_created": "Postingan feed diterbitkan",
  "feed.post_updated": "Pengaturan postingan diubah",
  "feed.post_hidden": "Postingan feed ditarik",
  "feed.post_restored": "Postingan feed ditayangkan kembali",
  "feed.comment_created": "Komentar feed dibuat",
  "feed.comment_hidden": "Komentar feed disembunyikan",
  "feed.comment_restored": "Komentar feed ditampilkan kembali",
  "feed.report_created": "Laporan konten dibuat",
  "feed.report_resolved": "Laporan konten ditutup",
  "feed.settings_updated": "Pengaturan feed diubah",
  "billing.settings_changed": "Pengaturan langganan diubah",
  "billing.run": "Tagihan bulanan disusun",
  "reseller.created": "Reseller dibuat",
  "reseller.updated": "Reseller diperbarui",
  "reseller.self_updated": "Reseller memperbarui pengaturannya",
  "reseller.account_created": "Akun reseller dibuat",
  "reseller.password_reset": "Sandi reseller direset",
  "school.reseller_assigned": "Reseller sekolah dipindahkan",
  "pengajuan.accepted": "Pengajuan sekolah diterima",
  "pengajuan.rejected": "Pengajuan sekolah ditolak",
  "pengajuan.submitted": "Reseller mengajukan sekolah",
  "school.reseller_contact_updated": "Kontak sekolah binaan dilengkapi reseller",
  "billing.claimed": "Sekolah menyatakan sudah bayar",
  "billing.claimed_by_school": "Sekolah melaporkan sudah bayar",
  "billing.confirmed": "Reseller mengonfirmasi pembayaran",
  "billing.confirmed_by_reseller": "Reseller konfirmasi & minta aktivasi",
  "billing.settlement_submitted": "Reseller melaporkan setoran",
  "billing.settlement_verified": "Setoran diverifikasi founder",
  "billing.settlement_cancelled": "Setoran dibatalkan",
  "billing.settlement_recorded": "Setoran dicatat founder",
  "billing.founder_channel_changed": "Kanal bayar founder diubah",
  "billing.status_changed": "Status tagihan diubah founder",
};

export const FIELD_LABELS = {
  status: "Status", role: "Peran", email: "Email", expires_at: "Berlaku hingga", name: "Nama",
  address: "Alamat", city: "Kabupaten/Kota", province: "Provinsi", phone: "Telepon",
  principal_name: "Kepala sekolah", website: "Situs web", rows: "Jumlah baris", match_on: "Dicocokkan pada",
  person_id: "ID identitas", platform_role: "Peran platform", npsn: "NPSN", code: "Kode", relation: "Hubungan",
  pending: "Menunggu", verified: "Terverifikasi",
};

export const LEVELS = ["SD", "MI", "SMP", "MTs", "SMA", "MA", "SMK", "Lainnya"];

export function valueLabel(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "Ya" : "Tidak";
  return (
    TENANT_STATUS[v]?.label || MEMBER_STATUS[v]?.label || INVITE_STATUS[v]?.label ||
    REVIEW_STATUS[v]?.label || ROLE_LABELS[v] || { verified: "Terverifikasi", ended: "Berakhir", ayah: "Ayah", ibu: "Ibu", wali: "Wali" }[v] || String(v)
  );
}

const fmt = new Intl.DateTimeFormat("id-ID", {
  timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
});

export function formatDate(iso) {
  if (!iso) return "—";
  return `${fmt.format(new Date(iso))} WIB`;
}

const rtf = new Intl.RelativeTimeFormat("id", { numeric: "auto" });

// Feed memakai waktu relatif agar terasa hidup; di atas 7 hari kembali ke tanggal penuh.
export function timeAgo(iso) {
  if (!iso) return "—";
  const selisih = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(selisih);
  // Jam server dan jam perangkat bisa beda beberapa detik; tanpa penjepitan ini
  // postingan baru terbaca "dalam 1 detik".
  if (abs < 60) return "baru saja";
  if (abs < 3600) return rtf.format(Math.round(selisih / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(selisih / 3600), "hour");
  if (abs < 604800) return rtf.format(Math.round(selisih / 86400), "day");
  return formatDate(iso);
}

export const FEED_KIND = {
  pengumuman: { label: "Pengumuman sekolah", tone: "info" },
  guru: { label: "Guru", tone: "muted" },
};

export const REPORT_REASONS = {
  spam: "Spam atau iklan",
  pornografi: "Konten pornografi",
  perundungan: "Perundungan",
  hoaks: "Hoaks/disinformasi",
  data_pribadi: "Memuat data pribadi siswa",
  lainnya: "Lainnya",
};

export const REPORT_STATE = {
  open: { label: "Menunggu tinjauan", tone: "warn" },
  resolved: { label: "Ditindaklanjuti", tone: "ok" },
  dismissed: { label: "Ditolak", tone: "muted" },
};

export const LINK_PREVIEW_STATUS = {
  ok: "Pratinjau tautan",
  failed: "Pratinjau gagal dimuat — tautan tetap dapat dibuka.",
  blocked: "Domain ini tidak diizinkan sekolah — tautan tetap dapat dibuka.",
};

export const ATTENDANCE_STATUS = {
  HADIR: { label: "Hadir", tone: "ok" },
  IZIN: { label: "Izin", tone: "info" },
  SAKIT: { label: "Sakit", tone: "warn" },
  ALPHA: { label: "Alpha", tone: "danger" },
};

export const CORRECTION_STATE = {
  NONE: { label: "Asli", tone: "muted" },
  CORRECTED: { label: "Dikoreksi", tone: "warn" },
};

export const CARD_STATUS = {
  active: { label: "Aktif", tone: "ok" },
  inactive: { label: "Nonaktif", tone: "muted" },
  lost: { label: "Hilang", tone: "danger" },
};

export const DEVICE_STATUS = {
  active: { label: "Aktif", tone: "ok" },
  inactive: { label: "Nonaktif", tone: "muted" },
};

export const EVENT_RESULT = {
  accepted: { label: "Diterima", tone: "ok" },
  rejected: { label: "Ditolak", tone: "danger" },
  unmatched: { label: "Tak dikenal", tone: "warn" },
};

export const REPORT_STATUS = {
  draft: { label: "Draf", tone: "warn" },
  published: { label: "Terbit", tone: "ok" },
};
